(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('ProfileCriterion', ProfileCriterion);

    ProfileCriterion.$inject = ['$resource'];

    function ProfileCriterion ($resource) {
        var resourceUrl =  'api/profile-criteria/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
